import { QueryKey } from '@tanstack/react-query'
import {
  MccGroupListModel,
  MccGroupListResponse,
} from 'src/models/mccGroup.models'
import { MCC_GROUPS_QK } from 'src/queries/queries.constants'
import { ExtendBaseQueryOptions, useExtendQuery } from 'src/queries/queries.utils'

export interface GetMccGroupListResponse {
  mccGroups: MccGroupListResponse[]
}

interface UseQueryMccGroupsProps
  extends ExtendBaseQueryOptions<
    GetMccGroupListResponse,
    MccGroupListModel[]
  > {
  additionalKey?: string
}

export const useQueryMccGroups = (props: UseQueryMccGroupsProps = {}) => {
  const { additionalKey, queryCacheOptions, ...rest } = props
  const queryKey: QueryKey = additionalKey
    ? [MCC_GROUPS_QK, additionalKey]
    : [MCC_GROUPS_QK]

  return useExtendQuery<GetMccGroupListResponse, MccGroupListModel[]>({
    queryKey,
    queryUrl: () => `/mccgroups`,
    select: (data: GetMccGroupListResponse) =>
      data?.mccGroups.map((mcc: MccGroupListResponse) => new MccGroupListModel(mcc)),
    ...queryCacheOptions,
    ...rest,
  })
}
